import { IBaseAction } from '@models/actions/IBaseAction';
import { ModalSize } from '@srm/ui/types/ModalSize';
import { DocBaseActionExecutor } from './DocBaseActionExecutor';
import { buildModalExecutorContext, IModalExecutorOptions } from './createModalExecutor';

/**
 * Экзекьютор действия документа, вся работа которого — собрать пропсы и показать модалку;
 * проверки accessibility остаются за {@link DocBaseActionExecutor}.
 */
export const createDocModalExecutor = <TProps extends object>(options: IModalExecutorOptions<TProps>) => {
    const Modal = options.modal;
    const empty = options.emptyElement ?? <></>;

    return class extends DocBaseActionExecutor {
        private _modalProps?: TProps;

        runInternal = (
            objId: string,
            parentId: string | undefined,
            action: IBaseAction,
            rowData?: any,
            completeHandler?: (isSucceed: boolean) => void,
            modalSize?: ModalSize | null,
        ) => {
            this._modalProps = options.mapProps(
                buildModalExecutorContext(options, objId, parentId, action, rowData, completeHandler, modalSize),
            );
        };

        visualElementInner = () => (this._modalProps ? <Modal {...this._modalProps} /> : empty);
    };
};
